<script lang="ts" setup>
import UspSlider from './components/UspSlider.vue';
import { useAemData } from '@/composables/useAemData';
import { useStageSwitchersStore } from '@/stores/stageSwitchers';
import { useTheme } from '@/stores/theme';
import UspLoading from './components/UspLoading.vue';
import { useVehicleStore } from '@/stores/vehicle';
import TextBlock from '@/components/TextBlock/TextBlock.vue';
import { useFetchData } from '@dh-io-owpi/shared/src/stores/fetchData';
import { buildUrl, fetchHighlights } from './utils';
import { watchEffect } from 'vue';
import { useTrackingStore } from '@dh-io-owpi/shared/src/stores/tracking';
import { type SectionName, sectionTrackLabelMap, useSectionsStore } from '@/stores/sections';

const theme = useTheme();
const aemData = useAemData();

const sectionsStore = useSectionsStore();

const switcherStore = useStageSwitchersStore();
const vehicleStore = useVehicleStore();
const { systemError } = useTrackingStore();

const { state } = useFetchData(
  () => switcherStore.brandId.value && buildUrl(aemData, switcherStore.brandId.value),
  fetchHighlights,
);

watchEffect(() => {
  if (state.value.error) {
    sectionsStore.setVisibility('usp', false);
    const uspSection: SectionName = 'usp';
    systemError({ action: 'pi_pages.sections', label: `load_fail.${sectionTrackLabelMap[uspSection]}` });
  }
  if (state.value.data?.length === 0) {
    sectionsStore.setVisibility('usp', false);
  }
});
</script>

<template>
  <template v-if="!state.error && state.data?.length !== 0">
    <TextBlock
      :subtitle="$t('usp.subline')"
      :headline="$t('usp.headline', { modelName: vehicleStore.stage?.modelName ?? '' })"
    />
    <section class="owpi-spa-usp">
      <UspLoading v-if="state.loading" :theme="theme.wb" />
      <UspSlider v-else-if="state.data" :theme="theme.wb" :items="state.data" />
    </section>
  </template>
</template>
<style lang="scss">
.owpi-spa-usp {
  $usp-ratio-height: 300px;
  min-height: $usp-ratio-height;

  @include breakpoint-to(mq3) {
    min-height: calc($usp-ratio-height + 15vw);
  }

  // From MQ3 onwards, the wb-slider reduces the image height, to maintain an approximate height according to the viewport width we reduce the vw
  @include breakpoint-from(mq3) {
    min-height: calc($usp-ratio-height + 5vw);
  }
}
</style>
